export default __webpack_public_path__ + "static/N0295-1494f63fce3bff7eb54899d61a264ad1.png";